import React, { useMemo } from "react";
import { Modal } from "antd";
import Image from "@/components/Image";
import styles from "./index.module.less";
import FilterSelect from "@/components/FilterSelect";
import constantFactory from "@gaoding/constant-factory";
import HBMessage from "@/components/HBMessage";
import HBIcon from "@/components/HBIcon";
import HBModel from "@/components/HBModal";
import { button_click } from "@/tracker/collecter/buttonClick";
export default function Index(props) {
  const {
    visable,
    setVisable,
    activeKey,
    pluginList,
    setActiveKey,
    problemHref,
  } = props;

  const onCancel = () => {
    setVisable(false);
  };
  const onCopy = (e) => {
    navigator.clipboard.writeText(e.target.innerText);
    HBMessage.success("地址复制成功");
  };
  const courseMap = {
    chrome: [
      {
        desc: (
          <>
            2.打开Chrome，在地址栏输入：
            <span className={styles.link} onClick={onCopy}>
              chrome://extensions/
            </span>
            ；并打开开发者模式。
          </>
        ),
        img: "https://cdn.dancf.com/fe-assets/20221220/chrome%E6%95%99%E7%A8%8B/ec6a38fb8343c6376d1a1484ee8ced9b.png",
      },
      {
        desc: "3.将下载的文件直接拖入到当前页面，并点击弹出窗口的“添加”。",
        img: "https://cdn.dancf.com/fe-assets/20221220/chrome%E6%95%99%E7%A8%8B/6e96161feb1aa19cae894b1fd515b9a9.png",
      },
      {
        desc: "4.安装完成。",
        img: "https://cdn.dancf.com/fe-assets/20221220/chrome%E6%95%99%E7%A8%8B/e587640e28287e30881a3cd0a1dec20c.png",
      },
    ],
    360: [
      {
        desc: "2.下载完成后对zip文件进行解压，通过【右键解压】 或 双击zip文件选择【解压到】桌面，解压后得到.crx文件。",
      },
      {
        desc: (
          <>
            3.打开360安全/极速浏览器，在地址栏输入：
            <span className={styles.link} onClick={onCopy}>
              chrome://extensions/
            </span>
            ；并打开开发者模式。
          </>
        ),
        img: "https://cdn.dancf.com/fe-assets/20221220/360%E6%95%99%E7%A8%8B/15096c2ca05ce95ff0526bca88f0632b.png",
      },
      {
        desc: "4.将下载的文件直接拖入到当前页面，并点击弹出窗口的“添加”。",
        img: "https://cdn.dancf.com/fe-assets/20221220/360%E6%95%99%E7%A8%8B/b5beac8279f8e8f764ca2058fb104237.png",
      },
      {
        desc: "5.安装完成。",
        img: "https://cdn.dancf.com/fe-assets/20221220/360%E6%95%99%E7%A8%8B/285c3e56fa3e3874a52f7965876fcf33.png",
      },
    ],
    qq: [
      {
        desc: "2.下载完成后对zip文件进行解压，通过【右键解压】 或 双击zip文件选择【解压到】桌面，解压后得到.crx文件。",
      },
      {
        desc: (
          <>
            3.打开QQ浏览器，在地址栏输入：
            <span className={styles.link} onClick={onCopy}>
              chrome://extensions/
            </span>
            ；并打开开发者模式。
          </>
        ),
        img: "https://cdn.dancf.com/fe-assets/20221220/QQ%E6%95%99%E7%A8%8B/bb504a7dac9826cae0ee11a9e56f6006.png",
      },
      {
        desc: "4.将下载的文件直接拖入到当前页面，并点击弹出窗口的“添加”。",
        img: "https://cdn.dancf.com/fe-assets/20221220/QQ%E6%95%99%E7%A8%8B/2f58a9a2682ebe0f5fa82e5e37fbd837.png",
      },
      {
        desc: "5.安装完成。",
        img: "https://cdn.dancf.com/fe-assets/20221220/QQ%E6%95%99%E7%A8%8B/721fc394ef6a22c5570647ad1bea8617.png",
      },
    ],
    sougou: [
      {
        desc: "2.下载完成后对zip文件进行解压，通过【右键解压】 或 双击zip文件选择【解压到】桌面，解压后得到.crx文件。",
      },
      {
        desc: (
          <>
            {" "}
            3.打开搜狗浏览器，在地址栏输入：
            <span className={styles.link} onClick={onCopy}>
              chrome://extensions/
            </span>
            ；并打开开发者模式。
          </>
        ),
        img: "https://cdn.dancf.com/fe-assets/20230306/%E6%90%9C%E7%8B%97%E9%85%8D%E5%9B%BE/393819efa4a212cd5844adecf4a37ad8.png",
      },
      {
        desc: "4.将下载的文件直接拖入到当前页面，并点击弹出窗口的“添加”。",
        img: "https://cdn.dancf.com/fe-assets/20230306/%E6%90%9C%E7%8B%97%E9%85%8D%E5%9B%BE/c8fe9ba3e2d35d31a46a776adc517edb.png",
      },
      {
        desc: "5.安装完成。",
        img: "https://cdn.dancf.com/fe-assets/20230306/%E6%90%9C%E7%8B%97%E9%85%8D%E5%9B%BE/21a39ad65583b066b92db1ac3ee21ed6.png",
      },
    ],
    other: [
      {
        desc: "2.下载完成后对zip文件进行解压，通过【右键解压】 或 双击zip文件选择【解压到】桌面，解压后得到.crx文件。",
      },
      {
        desc: (
          <>
            3.打开浏览器，在地址栏输入：
            <span className={styles.link} onClick={onCopy}>
              chrome://extensions/
            </span>
            ；并打开开发者模式。
          </>
        ),
        img: "https://cdn.dancf.com/fe-assets/20221220/360%E6%95%99%E7%A8%8B/15096c2ca05ce95ff0526bca88f0632b.png",
      },
      {
        desc: "4.将下载的文件直接拖入到当前页面，并点击弹出窗口的“添加”。",
        img: "https://cdn.dancf.com/fe-assets/20221220/360%E6%95%99%E7%A8%8B/b5beac8279f8e8f764ca2058fb104237.png",
      },
      {
        desc: "5.安装完成。",
        img: "https://cdn.dancf.com/fe-assets/20221220/360%E6%95%99%E7%A8%8B/285c3e56fa3e3874a52f7965876fcf33.png",
      },
    ],
  };
  const selectList = useMemo(() => {
    let list = [];
    // 过滤掉直接到应用商店的，且合并360和360fast浏览器
    pluginList.forEach((item) => {
      // 360极速版和没有离线包链接的
      if (item.value === "360fast") {
        return;
      }
      // 没有应用商城地址且有安装包地址 或者为chrome浏览器
      if ((!item.appStoreUrl && !!item.href) || item.value === "chrome") {
        // 如果是360的则合并
        list.push(item);
      }
    });

    const { PLUGIN_LIST, PLUGIN_ITEM_MAP } = constantFactory("PLUGIN", list);
    return {
      PLUGIN_LIST,
      PLUGIN_ITEM_MAP,
    };
  }, [pluginList]);
  const onChange = (item) => {
    setActiveKey(item.value);
  };
  const report = (e) => {
    button_click(e.target);
  };
  return (
    <HBModel
      width={720}
      // closable={false}
      title={
        <div className={styles.modalTitle}>
          <FilterSelect
            className={styles.sort}
            allowClear={false}
            options={selectList.PLUGIN_LIST}
            value={selectList.PLUGIN_ITEM_MAP[activeKey]}
            onChange={onChange}
          ></FilterSelect>
          <span className={styles.title}>{`${
            selectList.PLUGIN_ITEM_MAP[activeKey]?.value === "360"
              ? "360安全/极速浏览器"
              : selectList.PLUGIN_ITEM_MAP[activeKey]?.label
          } 安装流程`}</span>
          {/* <HBIcon type={"ic_close"} className={styles.closeIcon} onClick={onCancel}/> */}
        </div>
      }
      visible={visable}
      onCancel={onCancel}
      className={styles.modal}
      footer={null}
      bodyStyle={{
        padding: "0 32px 32px 32px",
        height: "78vh",
        overflow: "auto",
      }}
    >
      <div className={styles.content}>
        {activeKey === "chrome" && (
          <>
            <header>方法一、在线从Chrome应用商店安装</header>
            <div className={styles.mb24}>
              如果你能访问Google服务（需要网络代理工具），我们强烈建议你从
              <a
                target="_blank"
                href={selectList.PLUGIN_ITEM_MAP["chrome"].appStoreUrl}
                rel="noreferrer"
                className={styles.link}
                onClick={report}
                data-button-name={`${activeKey}浏览器插件-商店入口`}
              >
                &nbsp;谷歌官方扩展商店&nbsp;
              </a>
              进行安装，安装/更新都非常简单。
            </div>
            <header>方法二、下载安装包手动安装</header>
          </>
        )}
        <div>
          1.点击下方按钮，下载花瓣采集插件
          {activeKey === "qq" &&
            "(如不能正常安装，请更新QQ浏览器至最新版本再尝试)"}
          。
          {activeKey === "other" &&
            "支持遨游、华为等浏览器，暂不支持2345、UC浏览器。"}
        </div>
        <a
          className={styles.downloadBtn}
          href={
            !!selectList.PLUGIN_ITEM_MAP[activeKey]?.href &&
            selectList.PLUGIN_ITEM_MAP[activeKey].href
          }
          onClick={report}
          data-button-name={`${activeKey}浏览器插件-下载按钮`}
        >
          下载花瓣采集插件
        </a>
        {courseMap[activeKey]?.map((item, index) => {
          return (
            <div key={index}>
              <div className={styles.mb12}>{item.desc}</div>
              {item.img && (
                <Image
                  className={
                    index !== courseMap[activeKey]?.length - 1 && styles.mb24
                  }
                  alt=""
                  src={item.img}
                  width={656}
                  height={385}
                ></Image>
              )}
            </div>
          );
        })}
      </div>
      <a
        className={styles.footer}
        href={problemHref}
        target="_blank"
        rel="noreferrer"
      >
        <HBIcon className={styles.icon} type="connect" />
        <div>常见问题</div>
      </a>
    </HBModel>
  );
}
